import { AppIcons } from "../../../data/appIcons";
import { GridColumnType } from "../../../data/gridColumnType";

export const MemberApplicationTaskListConfig = {
  columns: [
    {
      name: "Subscription",
      fieldName: "subscription",
      colType: GridColumnType.Text,
    },
    {
      name: "Application Type",
      fieldName: "membershipType",
      colType: GridColumnType.Text,
    },
    {
      name: "Application Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },
    {
      name: "Company Name",
      fieldName: "companyName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Organisation Category",
      fieldName: "organisationCategoryName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
   
    
    {
      name: "Clarification Status",
      fieldName: "clarificationStatus",
      colType: GridColumnType.Text,
    },
    {
      name: "Action",
      fieldName: "action",
      allowShort: false,
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
      },
      customAction: [
        {
          name: "UPDATE",
          iconName: AppIcons.editIconNew,
          onViewAction: (data) => {
            alert("called permissions");
          },
        },
      ],
    },
  ],
};
